import { render, staticRenderFns } from "./ButtonRemoveUserTable.vue?vue&type=template&id=7c9cafe7&scoped=true"
import script from "./ButtonRemoveUserTable.vue?vue&type=script&lang=js"
export * from "./ButtonRemoveUserTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9cafe7",
  null
  
)

export default component.exports